// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2zKOF","rootSmall":"AddTileButton_rootSmall__3E5sm"};